module.exports = __webpack_public_path__ + "static/media/Pensions.c4e9b23a.jpg";